import { pageCountGet } from '../common';

export const dlUnitMaxPerPageGet = (state) => state.dlUnitLi.dlUnitMaxPerPage;
export const dlUnitCondGet = (state) => state.dlUnitLi.dlUnitCond;
export const dlUnitSkipValGet = (state) => (state.dlUnitLi.dlUnitPage - 1) * state.dlUnitLi.dlUnitMaxPerPage;

export const dlUnitPageCountGet = (state) => {
    let res = 0;
    if ( state !== 'undefined' && state.hasOwnProperty('dlUnitLi') ) {
        res = pageCountGet(state.dlUnitLi.dlUnitCount, state.dlUnitLi.dlUnitMaxPerPage);
    }
    return res;
};

export const dlUnitScanCountGet = (state) => {
    const n = ( state.dlUnit.dlUnit.hasOwnProperty('scans') ? state.dlUnit.dlUnit.scans.length : 0 );
    return n;
};

export const dlGroupSlugGet = (state) => state.dlGroup.dlGroupSlug;
export const dlGroupGet = (state) => state.dlGroup.dlGroup;
export const condUTypeGet = (state) => (state.dlUnitLi.hasOwnProperty('dlUnitCond') && state.dlUnitLi.dlUnitCond.hasOwnProperty('uType') ? state.dlUnitLi.dlUnitCond['uType'] : '' );
export const dlGroupUTypeGet = (state) => state.dlGroup.uType;

